<template>
    <a :href="phoneLink">
        {{ phone }}
    </a>
</template>

<script setup lang="ts">
import { useGooglePhoneConversion } from "../../functions/useGooglePhoneConversion";

const props = defineProps<{
    headquarters?: any;
}>();

const { phone, phoneLink, swapWithForwardingNumber } =
    useGooglePhoneConversion();

phone.value = props.headquarters.phone;
phoneLink.value = props.headquarters.phoneLink;
swapWithForwardingNumber(props.headquarters.phone);
</script>
